import { render } from "./RequestsView.vue?vue&type=template&id=09ea8a90&scoped=true"
import script from "./RequestsView.vue?vue&type=script&lang=js"
export * from "./RequestsView.vue?vue&type=script&lang=js"

import "./RequestsView.vue?vue&type=style&index=0&id=09ea8a90&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09ea8a90"]])

export default __exports__